var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#282828"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.441,
    cy: 3.441,
    r: 3.441,
    transform: "translate(9.294 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.756 20.378 2.028-2.027a.574.574 0 0 1 .81.81l-2.432 2.434a.574.574 0 0 1-.811 0l-1.217-1.217a.574.574 0 0 1 .811-.81l.811.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.897 21.762H7.573A.574.574 0 0 1 7 21.19v-.573a5.735 5.735 0 0 1 3.388-5.233c.687.41 1.49.645 2.346.645.857 0 1.66-.235 2.346-.645a5.736 5.736 0 0 1 2.97 3.08s-1.588-.845-2.727.293a1.721 1.721 0 0 0 0 2.433l.574.573z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCheck);
export default __webpack_public_path__ + "static/media/account-check.6c08a8465a47ac5e23a682dac7e1c809.svg";
export { ForwardRef as ReactComponent };